import { useEffect, useRef, useState } from 'react'

export function useHasUpdate() {
  const currentUpdateCommit = useRef<string | null>(null)
  const [hasUpdate, setHasUpdate] = useState(false)

  useEffect(() => {
    const getUpdateCommit = async () => {
      try {
        const response = await fetch('/assets/update-commit.txt', { cache: 'no-store' })
        if (response.status !== 200) {
          throw new Error(`Failed to fetch update commit: ${response.status}`)
        }
        const commit = await response.text()

        if (commit != '') {
          currentUpdateCommit.current = commit
        }
      } catch (_) {
        return
      }
    }
    getUpdateCommit()

    const checkForUpdate = async () => {
      try {
        const response = await fetch('/assets/update-commit.txt', { cache: 'no-store' })
        if (response.status !== 200) {
          throw new Error(`Failed to fetch update commit: ${response.status}`)
        }
        const commit = await response.text()

        if (commit == '') {
          throw new Error('Invalid update commit')
        }

        if (currentUpdateCommit.current === null) {
          currentUpdateCommit.current = commit
          return
        }

        if (commit != currentUpdateCommit.current) {
          setHasUpdate(() => true)
        }
      } catch (_) {
        return
      }
    }
    const intervalId = setInterval(checkForUpdate, 60 * 60 * 1000) // Check every hour
    return () => clearInterval(intervalId)
  }, [])

  return {
    hasUpdate,
  }
}
